// extracted by mini-css-extract-plugin
export default {"container":"NavigationActions_container__HHeaV","last":"NavigationActions_last__0aaEd","first":"NavigationActions_first__Ke9NM","manual":"NavigationActions_manual__L7ty2"};